import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_IDEA_FLOW } from './ViewIdeaFlowPlugin.types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ViewIdeaFlowReadyOnly = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('../components/ViewIdeaFlowReadOnly').then((mod) => mod.ViewIdeaFlowReadyOnly)
  )
);
interface ViewIdeaFlowPluginOptions {
  isReadOnly?: boolean;
}

export const ViewIdeaFlowReadOnlyPlugin = (
  options: ViewIdeaFlowPluginOptions = {}
): SlatePlugin => {
  return {
    inlineTypes: [ELEMENT_IDEA_FLOW],
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;

      if (element?.type === ELEMENT_IDEA_FLOW) {
        return <ViewIdeaFlowReadyOnly {...renderProps} {...options} />;
      }
      return undefined;
    },
  };
};
